import React from 'react';

// const defaultVal = {user: {}}
// export const Context = React.createContext(defaultVal);

const Context = React.createContext()
export default Context